<script setup lang="ts">
import SaveElemental from './SaveElemental.vue'
import { capitalizeFirstLetter } from '@/utils/formatting'
import { optimizeImage } from '@/composables/elements.client'
import type { Elemental } from '~~/src/types/elemental'
const props = defineProps<Props>()

defineOptions({
  name: 'CurrentListHeader',
})

interface Props {
  element?: Elemental
  type?: ElementalTypeEnum | null

}
const label = computed(() => getElementalTypeRoute(props.type ?? ElementalTypeEnum.unknown))
const user = useUser()
</script>

<template>
  <div :class="$style.container" class="py-3">
    <div
      :class="$style.avatar"
    >
      <img
        :src="element?.avatar ? optimizeImage(element?.avatar, { width: 40, height: 40 })
          : '/prompt_avatar.png'"
        class="w-10 h-10 border-1 border-soft-gray rounded-1"
      >
    </div>
    <p :class="$style.label" class="text-xs font-inter font-bold text-darkGray text-start">
      Saved to
    </p>
    <p :class="$style.name" class="text-sm font-inter font-bold text-darkGray text-start">
      All Saved {{ capitalizeFirstLetter(label) }}s
    </p>
    <div :class="$style.profile">
      <img
        :src="optimizeImage(user?.avatar, { width: 16, height: 16 })"
        class="w-3 h-3 border-1 border-soft-gray rounded-1"
        aria-label="You profile picture"
      >
      Personal
    </div>
    <div :class="$style.save">
      <SaveElemental :elemental="element" :elemental-type="type" />
    </div>
  </div>
</template>

<style lang="scss" module>
.container{
 display: grid;
 grid-template-areas:
    "avatar label save"
    "avatar name save"
    "avatar profile save";
  row-gap: 4px;
}
.save {
  grid-area: save;
  @apply flex items-center justify-end;

}
.profile {
  grid-area: profile;
  @apply flex gap-1 items-center text-xs font-inter font-bold text-darkGray;

}
.label {
  grid-area: label;
}
.name {
  grid-area: name;
  @apply color-softBlack;
}
.avatar {
  grid-area: avatar;
  @apply flex items-center justify-center;
}
</style>
